import React, { useEffect, useState } from "react";
import "./informationCaptureCard.scss";
import MainTitle from "../command/mainTitle/mainTitle";
// import { Link } from 'react-router-dom'
import FixFooterButton from "../command/fixFooterButton/fixFooterButton";
import Button from "../command/Button/Button";
import InformationCard from "../command/informationCard/informationCard";
import AddBillingAddressModal from "./addBillingAddressModal";
import CustomFieldsModal from "./customFieldsModal";
import PostRentalIDModal from "../verifyIdentityInfo/PostRentalIDModal";
import { Link, useNavigate } from "react-router-dom";
import { Effect } from "../../assets/svgIcon/customIcon";
import {
  AUTH_CRED,
  deleteCookie,
  getAuthCredentials,
  QUOTE_SESSION,
  setAuthCredentials,
} from "../../utils/auth-utils";
import { customerVerificationClient } from "../../data/verify-info";
import LoaderPage from "../command/loader/loader";
import { NotFound } from "../../pages";
import { InformationCaptureSmImage } from "../../assets/svgImages/svgImages";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { productDetailsClient } from "../../data/product-details";
import { useAuth } from "../../contexts/authContext";
import { GLOBAL_CONSTANTS } from "../../utils/constants";

const InformationCaptureCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [addAddressModalShow, setAddAddressModalShow] = useState(false);
  const [shippingAddress, setShippingAddress] = useState<any>();
  const [billingAddress, setBillingAddress] = useState<any>();
  const [addedAddress, setAddedAddress] = useState(true);
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [quote, setQuote] = useState<any>();
  const {cartItems, setCartItems} = useAuth();

  const { customerUuid, refreshToken, token, quoteId, userUuid, countryCode, isInternational } =
    getAuthCredentials();
  const [customerInfo, setCustomerInfo] = useState<any>();
  const [customeFromValue, setCustomeFromValue] = useState({
    firstName: "",
    lastName: "",
    dob: "",
  });
  const [addBilling, setAddBilling] = useState<boolean>(false);
  const [showCustomFieldsModal, setShowCustomFieldsModal] = useState(false);
  const [customFields, setCustomFields] = useState<any[]>([]);
  const [quoteData, setQuoteData] = useState<any>(null);
  const [allowPostRental, setAllowPostRental] = useState(false);
  const [retailerStoreName, setRetailerStoreName] = useState("");
  const [showPostRentalModal, setShowPostRentalModal] = useState(false);

  const calculateProductsInCart = (products: any) => {

    let cartQuantity: any = "";

    if(products && products.length > 0){
      cartQuantity = products.reduce((sum: any, item: any) => sum + item.productQuantity, 0);
    }

    return cartQuantity;
  }

  const getQuoteData = async () => {
    setLoading(true);
    await productDetailsClient
      .getProductDetailsList({ quoteUuid: quoteId })
      .then(async (data: any) => {
        if (data.quote.isDeleted) {
          toast.error("Something went wrong");
          setLoading(false);
        } else {
          setLoading(false);

          setQuote(data?.quote);
          if (data?.allowIDVerificationPostRental) {
            setAllowPostRental(true);
            setRetailerStoreName(data.storeDetails?.storeName ?? "");
          }
          if (data.products.length > 0) {
            localStorage.setItem("card-item", calculateProductsInCart(data?.products));
            setCartItems(calculateProductsInCart(data?.products));
          }
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
        setError(error.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (quoteId) {
      getQuoteData();
    }
  }, [quoteId]);

  useEffect(() => {
    let prepareCustomerInfoReponse: any = {};
    setLoading(true);
    customerVerificationClient
      .getCustomerInfo({ uuid: userUuid, quoteUuid: quoteId })
      .then((respnse: any) => {
        setLoading(false);
        setCustomerInfo(respnse);
        prepareCustomerInfoReponse = {
          dob: respnse?.customer?.dob || "",
          firstName: respnse?.customer?.firstName || "",
          lastName: respnse?.customer?.lastName || "",
          billingAddress: {
            housename: respnse?.billingAddress?.housename || "",
            postalcode: respnse?.billingAddress?.postalcode?.trim() || "",
            street: respnse?.billingAddress?.street || "",
            town: respnse?.billingAddress?.town || "",
            addressText: respnse?.billingAddress?.postalcode
              ? respnse?.billingAddress?.housename
                ? `${respnse?.billingAddress?.housename}, ${respnse?.billingAddress?.street}, ${respnse?.billingAddress?.town}, ${respnse?.billingAddress?.postalcode}`
                : `${respnse?.billingAddress?.street}, ${respnse?.billingAddress?.town}, ${respnse?.billingAddress?.postalcode}`
              : "",
          },
        };
        // let isValidUKPostalCode = ValidateUkPostalCode(respnse?.billingAddress?.postalcode);

        // if(!isValidUKPostalCode){
        //   prepareCustomerInfoReponse.billingAddress = {
        //     housename: "",
        //     postalcode: "",
        //     street: "",
        //     town: "",
        //     addressText: "",
        //   }
        // }

        setData(prepareCustomerInfoReponse);
        if (respnse?.billingAddress) {
          setBillingAddress(prepareCustomerInfoReponse.billingAddress);
        }
        if (respnse?.shippingAddress) {
          let prepareCustomerShippingInfo = {
            housename: respnse?.shippingAddress?.housename || "",
            postalcode: respnse?.shippingAddress?.postalcode,
            street: respnse?.shippingAddress?.street,
            town: respnse?.shippingAddress?.town,
            addressText: respnse?.shippingAddress?.housename
              ? respnse?.shippingAddress?.street
                ? `${respnse?.shippingAddress?.housename}, ${respnse?.shippingAddress?.street}, ${respnse?.shippingAddress?.town}, ${respnse?.shippingAddress?.postalcode}`
                : `${respnse?.shippingAddress?.housename}, ${respnse?.shippingAddress?.town}, ${respnse?.shippingAddress?.postalcode}`
              : respnse?.shippingAddress?.street
              ? `${respnse?.shippingAddress?.street}, ${respnse?.shippingAddress?.town}, ${respnse?.shippingAddress?.postalcode}`
              : `${respnse?.shippingAddress?.town}, ${respnse?.shippingAddress?.postalcode}`,
          }

          // let isValidUKPostalCode = ValidateUkPostalCode(prepareCustomerShippingInfo?.postalcode);

          // if(!isValidUKPostalCode){
          //   prepareCustomerShippingInfo = {
          //     housename: "",
          //     postalcode: "",
          //     street: "",
          //     town: "",
          //     addressText: "",
          //   }
          // }

          setShippingAddress(prepareCustomerShippingInfo);
          // if (respnse?.shippingAddress?.housename) {
          setAddedAddress(false);
          // }
        }
        localStorage.removeItem("journeyID");
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error?.message);
        setLoading(false);
        setError(error);
      });
    if (localStorage.getItem("journeyID")) {
      setLoading(true);
      const request = {
        customerUuid: customerUuid,
        journeyID: localStorage.getItem("journeyID"),
        quoteUuid: quoteId
      };
      customerVerificationClient
        .getCustomerDetails(request)
        .then((response: any) => {
          setLoading(false);
          if (response?.error) {
            setLoading(false);
            if (allowPostRental) {
              setShowPostRentalModal(true);
            } else {
              toast.error(response?.error);
              navigate("/cart");
            }
          } else {
            const prepareReponse: any = {
              name: "",
              dob: "",
              firstName: "",
              lastName: "",
              secondLastName: "",
              billingAddress: {
                housename: "",
                postalcode: "",
                street: "",
                town: "",
                addressText: "",
              },
            };

            let addressPostCode = "";
            let addressCity = "";

            response.data.forEach((entry: any) => {
              if (entry.Name === "AddressPostCode") {
                addressPostCode = entry.Value;
              } else if (entry.Name === "AddressCity") {
                addressCity = entry.Value;
              }
            });

            response.data.forEach((item: any) => {
              switch (item.Name) {
                case "FirstName":
                  prepareReponse.name += item.Value + " ";
                  prepareReponse.firstName = item.Value;
                  break;
                case "LastName":
                  prepareReponse.name += item.Value;
                  prepareReponse.lastName = item.Value;
                  break;
                case "SecondLastName":
                  prepareReponse.name += item.Value;
                  prepareReponse.secondLastName = item.Value;
                  break;
                case "FullName":
                  prepareReponse.name = item.Value;
                  const value = item.Value;
                  const lastSpaceIndex = value.lastIndexOf(' ');
                  prepareReponse.firstName = lastSpaceIndex !== -1 ? value.substring(0, lastSpaceIndex) : value;
                  prepareReponse.lastName = lastSpaceIndex !== -1 ? value.substring(lastSpaceIndex + 1) : '';
                  break;
                case "BirthDate":
                  prepareReponse.dob = item.Value;
                  break;

                case "AddressPostCode":
                  prepareReponse.billingAddress.postalcode = item.Value;
                  break;
                case "AddressCity":
                  prepareReponse.billingAddress.town = item.Value;
                  break;
                case "AddressFull":
                  prepareReponse.billingAddress.addressText = item.Value;
                  const addressParts = item.Value.split(", ");
                  // prepareReponse.billingAddress.housename =
                  //   addressParts[0].split(" ")[0];

                  // prepareReponse.billingAddress.street = `${addressParts[0]}, ${addressParts[1]}`;

                  // Remove AddressCity and AddressPostCode from AddressFull for street
                  const filteredAddressParts = addressParts.filter(
                    (part: string) => part !== addressPostCode && part !== addressCity
                  );
                  prepareReponse.billingAddress.street = filteredAddressParts.join(", ").trim();

                  // prepareReponse.billingAddress.town = addressParts[1];
                  // prepareReponse.billingAddress.postalcode = addressParts[2];
                  break;
                default:
                  break;
              }              
              // let postalCode = prepareReponse?.billingAddress?.postalcode ? prepareReponse?.billingAddress?.postalcode : "";

              // let isValidUKPostalCode = ValidateUkPostalCode(postalCode);

              // if(!isValidUKPostalCode){
              //     prepareCustomerInfoReponse.billingAddress = {
              //     housename: "",
              //     postalcode: "",
              //     street: "",
              //     town: "",
              //     addressText: "",
              //   }
              //   prepareReponse.billingAddress = {
              //     housename: "",
              //     postalcode: "",
              //     street: "",
              //     town: "",
              //     addressText: "",
              //   }
              // }
                
            });
            // Replace empty values in prepareReponseFromCustomerDetails with corresponding values from prepareReponseFromCustomerInfo
            const ensureNonNull = (value: any) =>
              value !== null && value !== undefined ? value : "";

            const mergedPrepareResponse = {
              dob:
                ensureNonNull(prepareReponse.dob) ||
                ensureNonNull(prepareCustomerInfoReponse.dob),
              firstName:
                ensureNonNull(prepareReponse.firstName) ||
                ensureNonNull(prepareCustomerInfoReponse.firstName),
              lastName:
                ensureNonNull(prepareReponse.lastName) ||
                ensureNonNull(prepareCustomerInfoReponse.lastName),
              secondLastName:
                ensureNonNull(prepareReponse.secondLastName) ||
                ensureNonNull(prepareCustomerInfoReponse.secondLastName),
              billingAddress: {
                housename:
                  ensureNonNull(prepareReponse.billingAddress.housename) ||
                  ensureNonNull(
                    prepareCustomerInfoReponse.billingAddress.housename
                  ),
                postalcode:
                  ensureNonNull(prepareReponse.billingAddress.postalcode) ||
                  ensureNonNull(
                    prepareCustomerInfoReponse.billingAddress.postalcode
                  ),
                street:
                  ensureNonNull(prepareReponse.billingAddress.street) ||
                  ensureNonNull(
                    prepareCustomerInfoReponse.billingAddress.street
                  ),
                town:
                  ensureNonNull(prepareReponse.billingAddress.town) ||
                  ensureNonNull(prepareCustomerInfoReponse.billingAddress.town),
                addressText:
                  ensureNonNull(prepareReponse.billingAddress.addressText) ||
                  ensureNonNull(
                    prepareCustomerInfoReponse.billingAddress.addressText
                  ),
              },
            };

            setData(mergedPrepareResponse);

            const setUserName = `${mergedPrepareResponse?.firstName}${" "} ${
              mergedPrepareResponse?.lastName
            }${" "}${mergedPrepareResponse?.secondLastName}`;
            if (prepareReponse.name) {
              setAuthCredentials(token, refreshToken, customerUuid, userUuid, {
                userName: setUserName,
              },
              countryCode, 
              isInternational);
            }
            if (mergedPrepareResponse.billingAddress) {
              setBillingAddress(mergedPrepareResponse.billingAddress);
            }
          }
          // setLoading(false);
        })
        .catch((error: any) => {
          toast.error("Please contact Renticy Support via live chat or Help Centre – Renticy");
          setLoading(false);
          setTimeout(() => {
            navigate("/cart");
          }, 5000);
        });
    }
  }, [customerUuid]);

//   const ValidateUkPostalCode = (postalCode: string) => {
//     if(postalCode){
//       const ukPostalCodeRegex = /^(GIR 0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/;
//       let isValidUKPostalCode = ukPostalCodeRegex.test(postalCode.toUpperCase());
//       return isValidUKPostalCode;
//     }else{
//       return false;
//     }
// }

  const cleanStreetAddress = (addressObject: any) => {    
    console.log("Address object", addressObject)
    if (addressObject && typeof addressObject === "object") {
      const { postcode, postalcode, county, town, street } = addressObject;

      let streetAddress: string = '';
      if (street && typeof street === "string") {
        const addressParts = street.split(", ").map(part => part.trim());

        // Remove postalcode, county, and town from the street address if they exist
        const filteredAddressParts = addressParts.filter(
          (part: string) => part !== postcode && part !== postalcode && part !== county && part !== town
        );

        // Update street with filtered values
        streetAddress = filteredAddressParts.join(", ").trim();
      }
      return streetAddress;
    }
  }

  const addCustomerDetails = () => {
    console.log("Billing address", billingAddress);
    console.log("Shipping address", shippingAddress);

    // setLoading(true);
    let shippingAddressData;

    if (!addedAddress && shippingAddress && shippingAddress?.addressText) {
      shippingAddressData = {
        housename: shippingAddress?.houseNameNumber
          ? shippingAddress?.houseNameNumber
          : shippingAddress?.housename
          ? shippingAddress?.housename
          : "",
        postalcode: shippingAddress?.postcode
          ? shippingAddress?.postcode.toUpperCase()
          : shippingAddress?.postalcode.toUpperCase(),
        street: cleanStreetAddress(shippingAddress),
        town: shippingAddress?.town,
        country: !isInternational ? GLOBAL_CONSTANTS.UNITEDKINGDOM : shippingAddress?.country
      };
    } else {
      shippingAddressData = {
        housename: billingAddress?.houseNameNumber
          ? billingAddress?.houseNameNumber
          : billingAddress?.housename
          ? billingAddress?.housename
          : "",
        postalcode: billingAddress?.postcode
          ? billingAddress?.postcode.toUpperCase()
          : billingAddress?.postalcode.toUpperCase(),
        street: cleanStreetAddress(billingAddress),
        town: isInternational ? billingAddress?.county: billingAddress?.town,
        country: !isInternational ? GLOBAL_CONSTANTS.UNITEDKINGDOM : billingAddress?.country
      };
    }
    const request = {
      uuid: userUuid,
      quoteUuid: quoteId,
      firstname: data.firstName ? data.firstName : customeFromValue?.firstName,
      lastname: data.lastName ? data.lastName : customeFromValue?.lastName,
      secondlastname: data.secondlastname,
      dob: data.dob ? data.dob : customeFromValue?.dob,
      isBillingAndShippingAddressSame: addedAddress,
      shippingAddress: {
        ...shippingAddressData,
      },
      billingAddress: {
        housename: billingAddress?.houseNameNumber
          ? billingAddress?.houseNameNumber
          : billingAddress?.housename
          ? billingAddress?.housename
          : "",
        postalcode: billingAddress?.postcode
          ? billingAddress?.postcode.toUpperCase()
          : billingAddress?.postalcode.toUpperCase(),
        street: cleanStreetAddress(billingAddress),
        town: isInternational ? billingAddress?.county: billingAddress?.town,
        country: !isInternational ? GLOBAL_CONSTANTS.UNITEDKINGDOM : billingAddress?.country
      },
    };

    customerVerificationClient
      .addCustomerDetails(request)
      .then((data: any) => {
        if (data) {
          customerVerificationClient
          .customerFraudcheck({ customerUuid: userUuid, quoteUuid: quoteId })
            .then((response: any) => {
              if (response?.error) {
                toast.error(response?.error);
                deleteCookie(AUTH_CRED);
                navigate("/cart");
                setLoading(false);
              } else if (response?.status === "ok") {
                productDetailsClient
                  .getProductDetailsList({ quoteUuid: quoteId })
                  .then((quoteResponse: any) => {
                    setLoading(false);
                    if (quoteResponse?.storeCustomFields && quoteResponse.storeCustomFields.length > 0) {
                      if (quoteResponse?.quoteCustomFieldValues && quoteResponse.quoteCustomFieldValues.length > 0) {
                        toast.success("Customer Details Updated Sucessfully");
                        navigate("/rental-summary");
                      } else {
                        setCustomFields(quoteResponse.storeCustomFields);
                        setQuoteData(quoteResponse);
                        setShowCustomFieldsModal(true);
                      }
                    } else {
                      toast.success("Customer Details Updated Sucessfully");
                      navigate("/rental-summary");
                    }
                  })
                  .catch((error: any) => {
                    setLoading(false);
                    toast.error(error?.message);
                    navigate("/rental-summary");
                  });
              } else {
                toast.error("Something went wrong");
                deleteCookie(AUTH_CRED);
                navigate("/cart");
                setLoading(false);
              }
            })
            .catch((error) => {
              toast.error(error.message);
              setLoading(false);
            });
        }
      })
      .catch((error: any) => {
        toast.error(error?.message);
        setError(error.message);
        setLoading(false);
      });
  };

  if (loading) {
    <LoaderPage />;
  }

  if (error) {
    return <NotFound />;
  }
  const isButtonDisabled = () => {
    console.log(data)
   return !(
    (data?.firstName ? data?.firstName : customeFromValue?.firstName) &&
    (data?.lastName ? data?.lastName : customeFromValue?.lastName) &&
    (data?.dob ? data?.dob : customeFromValue?.dob)
  )
};

  const handleCustomFieldsSubmit = (values: any) => {
    setLoading(true);
    
    const quoteCustomFieldValues = Object.keys(values).map((fieldKey) => {
      const field = customFields.find((f) => f.fieldKey === fieldKey);
      return {
        fieldKey: fieldKey,
        fieldLabel: field?.label || fieldKey,
        fieldValue: values[fieldKey],
      };
    });

    const request = {
      customerQuoteUuid: quoteData?.quote?.uuid || quoteId,
      quoteCustomFieldValues: quoteCustomFieldValues,
    };

    productDetailsClient
      .updateCustomerQuote(request, token)
      .then((response: any) => {
        setLoading(false);
        setShowCustomFieldsModal(false);
        toast.success("Customer Details Updated Successfully");
        navigate("/rental-summary");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.message || "Failed to update custom fields");
      });
  };

  const areAllFieldsEmpty = (data: any): boolean => {
    if (data === undefined) return true; // treat undefined as empty

    if (typeof data !== 'object' || data === null) {
      return data === '' || data === null;
    }

    return Object.values(data).every(value => areAllFieldsEmpty(value));
  };

  // Final combined check
  const isAllEmpty = areAllFieldsEmpty(data) && areAllFieldsEmpty(shippingAddress);

  console.log("All fields empty:", isAllEmpty); // true only if everything is empty


  return (
    <>
      {loading ? (
        <LoaderPage />
      ) : (
        <>
          {" "}
          <section className="section-space information-capture">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="effect-add-section">
                    <Effect className="effect-img" />
                    <div className="information-capture-box">
                      <div className="row gx-lg-5">
                        <div className="col-md-12 order-lg-1 order-2">
                          <MainTitle
                            mainText={!isAllEmpty ? t("information-weve-captured"): t("please-enter-your-details")}
                          />
                        </div>
                        <div className="col-xl-6 col-lg-6 order-xl-1 order-lg-1 order-3">
                          <div className="capture-info-box">
                            <InformationCard
                              userInfo={data}
                              shippingAddress={shippingAddress?.addressText}
                              billingAddress={billingAddress?.addressText}
                              setCustomeFromValue={setCustomeFromValue}
                              customerInfo={customeFromValue}
                            />
                            {quote?.deliveryMethod !== "Collect from Store" &&
                              ((billingAddress &&
                                billingAddress?.addressText) ||
                                (shippingAddress &&
                                  shippingAddress?.addressText)) && (
                                <Link
                                  to={"#"}
                                  onClick={() => {
                                    setAddAddressModalShow(true);
                                    setAddedAddress(false);
                                  }}
                                  className="site-link mt-2 sa-link"
                                >
                                  {shippingAddress &&
                                  shippingAddress?.addressText
                                    ? t("edit-shipping-address")
                                    : t("add-shipping-address")}
                                </Link>
                              )}

                            <FixFooterButton className="capture-info-button">
                              {quote?.deliveryMethod !==
                                "Collect from Store" && (
                                <p className="hint-text">
                                  Your delivery and order details will be
                                  reviewed by the Retailer before shipment.
                                </p>
                              )}
                              <Button
                                disabled={isButtonDisabled()}
                                btnText={
                                  billingAddress?.postalcode || billingAddress?.postcode
                                    ? t("continue")
                                    : t("add-billing-address")
                                }
                                onClick={() => {
                                  billingAddress?.postalcode || billingAddress?.postcode
                                    ? addCustomerDetails()
                                    : setAddAddressModalShow(true);
                                  setAddBilling(true);
                                }}
                              />
                            </FixFooterButton>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 order-xl-2 order-lg-2 order-1">
                          <div className="information-capture-img">
                            <img
                              className="img-fluid d-none d-lg-block"
                              src="./images/information-captured.png"
                              alt="verify-identity-img"
                            />
                            <InformationCaptureSmImage className="img-fluid d-block d-lg-none" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <AddBillingAddressModal
            show={addAddressModalShow}
            shippingaddresstext={shippingAddress}
            billingaddresstext={addBilling}
            isInternational={isInternational}
            onContinue={(value: any) => {
              if(addBilling){
                setBillingAddress(value);
                return
              }
              if (!addedAddress) {
                setShippingAddress(value);
              } else {
                setBillingAddress(value);
              }
            }}
            onHide={() => {
              setAddAddressModalShow(false);
              setAddBilling(false);
            }}
          />
          <CustomFieldsModal
            key={customFields.map((f) => f.fieldKey).join(",")}
            show={showCustomFieldsModal}
            onHide={() => setShowCustomFieldsModal(false)}
            onSubmit={handleCustomFieldsSubmit}
            customFields={customFields}
            loading={loading}
          />
          <PostRentalIDModal
            show={showPostRentalModal}
            storeName={retailerStoreName}
            onContinue={() => {
              setShowPostRentalModal(false);
            }}
            onCancel={() => {
              setShowPostRentalModal(false);
              navigate("/cart");
            }}
            onHide={() => setShowPostRentalModal(false)}
          />
        </>
      )}

      {/* <ToastMessage
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
        type={toastType}
      /> */}
    </>
  );
};

export default InformationCaptureCard;
